<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(libraryId) ? 'Edit' : 'Add'}} Library</h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1" editable>Library Details</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2" @click="updateValidate" :editable="libraryId ? true : false">Library Image</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body" step="1">
                  <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
                    <v-row>
                      <v-col cols="6">
                        <label class="form-control-label">
                          Name
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="library.name"
                          placeholder="Enter Library Name"
                          :rules="[(v) => !!v || 'Title is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          required
                          solo
                        ></v-text-field>
                      </v-col>
                     
                      <v-col cols="6">
                        <label class="form-control-label">
                          Publisher
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="library.publisher"
                          solo
                          label="Enter Publisher"
                          :rules="[(v) => !!v || 'Publisher is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                        ></v-text-field>
                      </v-col>

                        <v-col cols="6">
                          <v-card-title class="pt-8 pr-0 justify-start">
                            <h4>Active</h4>
                            <v-switch class="pl-4 pt-3 mt-0" v-model="library.isActive" flat:label="Yes" inset></v-switch>
                          </v-card-title>
                        </v-col>

                      <v-col class="text-right" cols="12">
                        <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                        <v-btn
                          v-if="!libraryId"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="saveValidate"
                        >Next</v-btn>
                        <v-btn
                          v-if="libraryId"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="updateValidate"
                        >Next</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content class="v-form-body" step="2">
                  <v-row>
                    <v-col :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'" class="pa-5">
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Library Image</span>
                        </v-card-title>
                        <v-card-text>
                          <vue-dropzone
                            class="vue-dropzone-box"
                            ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-sending="beforecomplete"
                            @vdropzone-success="aftercomplete"
                            @vdropzone-mounted="uploadedImage"
                            @vdropzone-removed-file="removeFile"
                            :useCustomSlot="true"
                            :useCustomDropzoneOptions="true"
                          >
                            <div class="dropzone-custom-content">
                              <img src="@/assets/images/ImageUpload.svg" />
                              <h3 class="font-weight-light ma-0">Drag and drop here to upload</h3>
                              <h3 class="font-weight-light ma-0">Or</h3>
                              <h3 class="dropzone-custom-title">Browse</h3>
                            </div>
                          </vue-dropzone>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <document-upload
                      :documents="documents"
                       moduleName="education/library"
                      :moduleId="libraryId"
                      v-if="e1 == 2"
                      :maxFiles="1"
                    ></document-upload>
                  </v-row>
                  <v-col class="text-right" cols="12">
                    <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="#344452"
                      class="white--text"
                      :loading="loading"
                      @click="save"
                    >{{(libraryId) ? 'Update' : 'Save'}}</v-btn>
                  </v-col>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CommonSection from "@/components/CommonHeader";
import { MediaService, LibraryService } from "@/services";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { MEDIATYPE_THUMBNAIL, CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT} from "@/constants";
import { ImageValidateMixin } from "@/mixins";

export default {
  name: "AddLibrary",
  components: {
    CommonSection,
    vueDropzone: vue2Dropzone,
    documentUpload: () => import("@/components/DocumentUpload"),
  },
  mixins: [ImageValidateMixin],
  data() {
    var self = this;
    return {
      e1: 1,
      loading: false,
      open: ["public"],
      valid: true,
      libraryId: null,
      status: false,
      media: [],
      library: {
        name: null,
        isActive: false,
        publisher: null,
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        addRemoveLinks: true,
        autoProcessQueue: true,
        maxFilesize: 2, // MB
        thumbnailWidth: 300,
        maxFiles: 1,
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        acceptedFiles: "image/*",
          init() {
            this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
           });
           this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 2) {
              // not more than 2mb
              this.removeFile(file);
            }
          });
            this.on("thumbnail",(file) => {
              self.validateBannerDimension(file, CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT)
            });
          },
          accept(file, done) {
            self.showError(file, CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT,done)
          }
      },
      editorOption: {
        theme: "snow",
      },
    };
  },
  computed: {
    documents() {
      if (this.media && this.media.length > 0) {
        return this.media.filter((media) => media.mediaType == "doc");
      } else {
        return [];
      }
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id !== 'create') { 
        this.libraryId = this.$route.params.id
        await this.getLibraryData();
        await this.uploadedImage();
      }
    },
    async getLibraryData() {
      let library;
      if(this.$route.params.id === "create")      
      library = await LibraryService.getLibrary(this.libraryId);
      else{
        library = await LibraryService.getLibrary(this.$route.params.id);
      }
      this.library.name = library.data.data[0].name;
      this.library.publisher = library.data.data[0].publisher;
      this.library.isActive = library.data.data[0].isActive;
      this.media = library.data.data[0].media;
    },
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "image");
      formData.append("moduleType", "education/library");
      formData.append("mediaSubType", "file");
      formData.append("imageType", MEDIATYPE_THUMBNAIL);
      formData.append("moduleId", this.libraryId);
    },
    aftercomplete(file, response) {
      this.$store.dispatch(
        "user/setSnack",
        "Library Image uploaded successfully!"
      );
      this.getLibraryData();
      this.$store.dispatch("user/setType", "info");
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
    removeFile(file, error, xhr) {
      if (file.size > 1024 * 1024 * 2) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 2MB File size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "education/library",
                moduleId: this.libraryId,
              },
            });
            this.getLibraryData();
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "Library image deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$router.push("/library");
    },
    async saveValidate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await LibraryService.createLibrary(this.library);
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.libraryId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              "Library added successfully!"
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async updateValidate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await LibraryService.updateLibrary({
            id: this.libraryId,
            object: this.library,
          });
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.libraryId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              "Library updated successfully!"
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.loading = false;
          this.$router.push("/library");
          this.$store.dispatch("user/setSnack", `Library ${(this.libraryId) ?  'updated' : 'added'} successfully!`);
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.main-content .navbar-top {
  display: none !important;
}
</style>